import React from 'react'
import PropTypes from 'prop-types'

import { Box, Typography } from '@material-ui/core'
import { useTheme } from '@material-ui/core/styles'

import MosaicPrices from 'artkive/components/MosaicPrices'
import ProductDescriptionItem from 'artkive/components/PageSections/ProductDescriptionItem'
import { TrackButton } from 'artkive/components/Tracker'
import { GET_BOX_CLICK } from 'artkive/constants/tracker/mainNavigation'
import useMobileBreakpoint from 'artkive/hooks/useMobileBreakpoint'
import useSale from 'artkive/hooks/useSale'
import { pricingMosaicBullets } from 'artkive/pages/Pricing/Pricing.constants'

import Mosaics from 'images/ecom/pricing/Mosaics.png'
import MosaicsX2 from 'images/ecom/pricing/Mosaics-x2.png'
import StorageBadge from 'images/ecom/StorageBadge.svg'

import ImageTextSection, { Picture } from '../ImageTextSection'
import { boxProductDisclaimers } from '../Pricing.constants'

import { ImageBox, StorageBadgeImage } from './MosaicsSection.style'

const MosaicsSection = ({ large, small }) => {
  const muiTheme = useTheme()

  const isMobile = useMobileBreakpoint()
  const { boxCheckoutUrl } = useSale()

  return (
    <ImageTextSection
      bgColor='#E9E6F1'
      imageContent={
        <ImageBox>
          <StorageBadgeImage src={StorageBadge} alt='+ 3 Months Storage' />
          <Picture>
            <source srcSet={`${MosaicsX2}`} media={muiTheme.breakpoints.up('lg').replace('@media ', '')} />
            <source
              srcSet={`${Mosaics}, ${MosaicsX2} 2x`}
              media={muiTheme.breakpoints.up('md').replace('@media ', '')}
            />
            <img srcSet={`${Mosaics}, ${MosaicsX2} 2x`} src={Mosaics} alt='Mosaics preview' />
          </Picture>
        </ImageBox>
      }
      descriptionContent={
        <div>
          <Typography variant='h2' align={isMobile ? 'center' : 'left'}>
            Framed Mosaics
          </Typography>
          <Box mt={3}>
            {pricingMosaicBullets.map(({ text }, index) => (
              <ProductDescriptionItem key={index}>{text}</ProductDescriptionItem>
            ))}
          </Box>
          <MosaicPrices large={large} small={small} asterisks={boxProductDisclaimers} />
          <Box display='flex' justifyContent={isMobile ? 'center' : 'left'} mt={5}>
            <TrackButton
              color='primary'
              href={boxCheckoutUrl}
              size='large'
              variant='contained'
              trackerEvent={GET_BOX_CLICK}
              trackerOptions={{
                section: 'get_mosaics_section',
              }}
            >
              Get My Box
            </TrackButton>
          </Box>
        </div>
      }
    />
  )
}

MosaicsSection.propTypes = {
  large: PropTypes.shape({
    non_bundle_price: PropTypes.number.isRequired,
    price: PropTypes.number.isRequired,
    width: PropTypes.string.isRequired,
    height: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
  small: PropTypes.shape({
    non_bundle_price: PropTypes.number.isRequired,
    price: PropTypes.number.isRequired,
    width: PropTypes.string.isRequired,
    height: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
}

export default MosaicsSection
